const AppEnvironment = ['val-sandbox', 'verify-dev', 'verify-val'];

const getEnvironmentFromHostname = (): string | null => {
  const { hostname } = window.location;

  const envUrl = hostname.split('.')[0];
  if (AppEnvironment.includes(envUrl)) {
    return envUrl;
  }

  // FOR TESTING WILL REMOVE ONCE TESTING IS DONE
  const urlParams = new URLSearchParams(window.location.search);
  const envParam = urlParams.get('env');
  if (envParam && AppEnvironment.includes(envParam)) {
    return envParam;
  }

  return null;
};

export const useEnvironment = (): string | null => {
  return getEnvironmentFromHostname();
};
